import { map } from './Map.js';

// كلما تغير دوران الخريطة، لف الإبرة المعاكس لاتجاه الخريطة وتحديث الدرجات
map.getView().on('change:rotation', function () {
  const rotation = map.getView().getRotation();
  const compassNeedle = document.querySelector('.compass-needle');
  const degreeLabel = document.getElementById('rotationDegrees');
  const northBtn = document.getElementById('resetNorthBtn');

  if (compassNeedle) {
    compassNeedle.style.transform = `rotate(${-rotation}rad)`;
  }

  if (degreeLabel) {
    // تحويل الراديان إلى درجات وتقريبها
    const degrees = Math.round((-rotation * 180) / Math.PI) % 360;
    const absDegrees = degrees < 0 ? degrees + 360 : degrees;
    degreeLabel.textContent = `${absDegrees}°`;

    // إظهار/إخفاء الليبل بناءً على الدوران
    if (northBtn) {
      if (Math.abs(rotation) > 0.01) {
        northBtn.classList.add('is-rotated');
      } else {
        northBtn.classList.remove('is-rotated');
      }
    }
  }
});

// منع التداخل مع الأدوات الأخرى عند الضغط على البوصلة (حماية شاملة لكافة الأحداث)
['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(evt => {
  document.getElementById('resetNorthBtn').addEventListener(evt, (e) => e.stopPropagation());
});

// عند الضغط على الزر، ترجع الخريطة للشمال
document.getElementById('resetNorthBtn').addEventListener('click', function (e) {
  e.preventDefault();
  e.stopPropagation();
  map.getView().animate({ rotation: 0, duration: 500 });
});


let isRPressed = false;
let isRotating = false;
let lastX = 0;

// عند ضغط حرف R
document.addEventListener('keydown', (e) => {
  if (['INPUT', 'TEXTAREA'].includes(e.target.tagName)) return;
  if (e.key.toLowerCase() === 'r') {
    isRPressed = true;
  }
});

// عند إفلات حرف R
document.addEventListener('keyup', (e) => {
  if (['INPUT', 'TEXTAREA'].includes(e.target.tagName)) return;
  if (e.key.toLowerCase() === 'r') {
    isRPressed = false;
    isRotating = false;
  }
});

// عند بدء سحب الماوس
map.getTargetElement().addEventListener('mousedown', (e) => {
  if (isRPressed) {
    // ⚡ إيقاف المتابعة التلقائية عند الدوران اليدوي
    if (window.GeoPST_Geolocation && typeof window.GeoPST_Geolocation.stopFollowing === 'function') {
      window.GeoPST_Geolocation.stopFollowing();
    }
    isRotating = true;
    lastX = e.clientX;
  }
});

// عند تحريك الماوس
map.getTargetElement().addEventListener('mousemove', (e) => {
  if (isRPressed && isRotating) {
    const deltaX = e.clientX - lastX;
    lastX = e.clientX;

    const view = map.getView();
    const rotation = view.getRotation();
    view.setRotation(rotation - deltaX * 0.005);
  }
});

// عند إفلات الزر
document.addEventListener('mouseup', () => {
  isRotating = false;
});